// src/components/Header.jsx

import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import '../css/Header.css';


const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  //used to update login page and update page
  const location = useLocation();

  // Check if the user is logged in based on localStorage
  useEffect(() => {
    const checkLoginStatus = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token); // If token exists, user is logged in
    };

    // Initial check
    checkLoginStatus();
  }, [location]);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove the token from localStorage
    setIsLoggedIn(false); // Update the state to reflect logged-out status
    navigate('/login'); // Redirect to login page
  };

  return (
    <header>
      <Navbar expand="lg" bg="light" variant="light" sticky="top">
        <Container>
          <Navbar.Brand href="/">My Website</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/search">Search</Nav.Link>
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/cart">Cart</Nav.Link>
              <Nav.Link as={Link} to="/product-list">Products</Nav.Link>
              <Nav.Link as={Link} to="/orderList">Oder History</Nav.Link>
              <Nav.Link as={Link} to="/add-product">Add Product</Nav.Link>
              {isLoggedIn ? (
                <>
                  <Nav.Link as={Link} to="/update">Update</Nav.Link>
                  <Nav.Link as="button" onClick={handleLogout}>Logout</Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} to="/login">Login</Nav.Link>
                  <Nav.Link as={Link} to="/register">Register</Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
